import { render } from "./WrapMenu.vue?vue&type=template&id=680215a0&scoped=true"
import script from "./WrapMenu.vue?vue&type=script&lang=js"
export * from "./WrapMenu.vue?vue&type=script&lang=js"

import "./WrapMenu.vue?vue&type=style&index=0&id=680215a0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680215a0"]])

export default __exports__